module.exports = __webpack_public_path__ + "img/header-diamondJewelry100Carat@2x.d9674ff.jpg";